import { BASE_URL } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";
export class COV19ReportingService {
  public async submitCov19Reporting(data: any, companyId: any) {
    let obj = { companyId: companyId, data: data };
    try {
      let response = await fetch(`${BASE_URL}/cov19/reporting/submit/`, {
        method: "POST",
        headers: AuthUtils.getHeaders(),
        body: JSON.stringify(obj),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async getCov19ReportingByCompanyId(companyId: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/cov19/reporting/companies/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public getCov19ReportingByCompanyIdAsync(
    companyId: any,
    onSuccess: any,
    onFailure: any
  ) {
    try {
      fetch(`${BASE_URL}/cov19/reporting/companies/${companyId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      }).then((resp: any) => {
        onSuccess(resp.json());
      });
    } catch (e:any) {
      onFailure(e);
    }
  }
}
